import { assoc, compose, pick } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useSaveIntegrations } from '../../_requests/saveIntegrations'
import Form from '../../../../../packages/kiti/components/form/form/Form'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../packages/kiti/components/form/SubmitBar'

const cleanRequest = form => {
  return compose(
    pick(['id', 'service', 'name', 'token']), //
    item => assoc('name', 'D4Sign', item),
    item => assoc('service', 'D4SIGN', item),
    item => assoc('token', `${item.tokenApi}:${item.cryptKey}`, item)
  )(form)
}

const FormD4Sign = ({ integrationId, moveBackOnSuccess, ...props }) => {
  const { t } = useTranslation('listIntegrations')
  const [save, { loading, error }] = useSaveIntegrations(cleanRequest, moveBackOnSuccess)

  return (
    <Form initialState={{ id: integrationId, service: 'd4sign' }} onSubmit={save}>
      <FormItem label={t('d4sign.tokenApi')} field="tokenApi" />
      <Separator weight={2} />
      <FormItem label={t('d4sign.cryptKey')} field="cryptKey" />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default FormD4Sign
